/** Mapeia IDs do catálogo de calculadoras → passo do guia com ferramenta embutida. */
export const CALC_TO_PASSO: Record<string, { moduloId: string; topicoId: string }> = {
  // Terreno (RF-08A)
  topografia: { moduloId: 'terreno', topicoId: 'topografia' },
  'corte-aterro': { moduloId: 'terreno', topicoId: 'corte-aterro' },
  insolacao: { moduloId: 'terreno', topicoId: 'insolacao' },
  sondagem: { moduloId: 'terreno', topicoId: 'sondagem' },
  // Sistemas (RF-08B)
  sistemas: { moduloId: 'sistemas-construtivos', topicoId: 'sistemas' },
  espessura: { moduloId: 'sistemas-construtivos', topicoId: 'espessura' },
  vaos: { moduloId: 'projetos', topicoId: 'vaos' },
  // Projetos (RF-08C)
  casca: { moduloId: 'projetos', topicoId: 'casca' },
  comodo: { moduloId: 'projetos', topicoId: 'comodo' },
  otimizador: { moduloId: 'projetos', topicoId: 'otimizador' },
  aberturas: { moduloId: 'projetos', topicoId: 'aberturas' },
  'pe-direito': { moduloId: 'projetos', topicoId: 'pe-direito' },
  // Planejamento financeiro (RF-08D)
  viabilidade: { moduloId: 'planejamento-financeiro', topicoId: 'viabilidade' },
  'curva-s': { moduloId: 'planejamento-financeiro', topicoId: 'curva-s' },
  reserva: { moduloId: 'planejamento-financeiro', topicoId: 'reserva' },
  financiamento: { moduloId: 'planejamento-financeiro', topicoId: 'financiamento' },
  inflacao: { moduloId: 'planejamento-financeiro', topicoId: 'inflacao' },
  // Mão de obra (RF-08E)
  contratacao: { moduloId: 'mao-de-obra', topicoId: 'contratacao' },
  equipe: { moduloId: 'mao-de-obra', topicoId: 'equipe' },
  pedreiro: { moduloId: 'mao-de-obra', topicoId: 'pedreiro' },
  aditivos: { moduloId: 'mao-de-obra', topicoId: 'aditivos' },
  // Tributos (RF-08F)
  impostos: { moduloId: 'tributos', topicoId: 'impostos' },
  inss: { moduloId: 'tributos', topicoId: 'inss' },
  cno: { moduloId: 'tributos', topicoId: 'cno' },
  habitese: { moduloId: 'tributos', topicoId: 'habitese' },
  // Execução (RF-08G)
  cronograma: { moduloId: 'execucao', topicoId: 'cronograma' },
  'anti-retrabalho': { moduloId: 'execucao', topicoId: 'anti-retrabalho' },
  atrasos: { moduloId: 'execucao', topicoId: 'atrasos' },
  'manta-telhado': { moduloId: 'execucao', topicoId: 'manta-telhado' },
}

/** Etapa do guia relacionada — link “Ver na etapa do guia”. */
export const CALC_TO_GUIA_TOPICO: Record<string, string> = {
  topografia: 'terreno-01',
  'corte-aterro': 'terreno-02',
  insolacao: 'terreno-09',
  sondagem: 'terreno-20',
  sistemas: 'sc-09',
  espessura: 'sc-03',
  vaos: 'proj-09',
  casca: 'proj-13',
  comodo: 'proj-05',
  otimizador: 'proj-07',
  aberturas: 'fin-08',
  'pe-direito': 'proj-10',
  viabilidade: 'fin-11',
  'curva-s': 'fin-02',
  reserva: 'fin-01',
  financiamento: 'fin-13',
  inflacao: 'fin-12',
  contratacao: 'mdo-03',
  equipe: 'mdo-08',
  pedreiro: 'mdo-01',
  aditivos: 'mdo-02',
  impostos: 'trib-00',
  inss: 'trib-06',
  cno: 'trib-04',
  habitese: 'trib-03',
  cronograma: 'exe-06',
  'anti-retrabalho': 'exe-04',
  atrasos: 'exe-06',
  'manta-telhado': 'exe-11',
}

export function getPassoForCalc(calcId: string) {
  return CALC_TO_PASSO[calcId] ?? null
}

export function getGuiaTopicoForCalc(calcId: string) {
  return CALC_TO_GUIA_TOPICO[calcId] ?? null
}
